module.exports = __webpack_public_path__ + "static/img/15_pro.ba36959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/15_pro.jpg
// module id = iJor
// module chunks = 0